import i18next from 'i18next'
import { List } from 'immutable'
import { listFromOption, loadingAsyncState } from 'widgets-for-react'
import { TypeCastingValidator, canSafelyCast } from '../../../../utils/safe-type-casting'
import { componentTeaserValidator } from '../../components/componentTeasers/componentTeasersApi'
import {
  ComponentTeaserData,
  initialComponentTeasersState,
} from '../../components/componentTeasers/componentTeasersState'
import { getSearchResults } from '../../search/searchApi'
import { AdditionalSubsectionData } from './loggedInHomeState'

export async function getLastViewedComponents(): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const response = await fetch(
    `/api/v1/components/recent?pageSize=6&language=${i18next.language}`,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

async function getAdditionalSubsections(): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const response = await fetch(
    `/api/v1/components/groups?language=${i18next.language}`,
    {
      method: 'get',
      headers: headers,
    }
  )
  if (!response.ok) throw Error(response.statusText)
  return await response.json()
}

const additionalSubsectionValidator: TypeCastingValidator<AdditionalSubsectionData> =
  {
    kind: 'object',
    fieldsValidator: {
      Id: { kind: 'number' },
      Name: { kind: 'string' },
      Query: { kind: 'string' },
      Description: { kind: 'string' },
    },
  }

export const loadAdditionalSubsections = loadingAsyncState(() =>
  getAdditionalSubsections().then((raw) => {
    if (Array.isArray(raw))
      return {
        kind: 'result',
        value: List(raw)
          .map((v) =>
            canSafelyCast<AdditionalSubsectionData>(
              additionalSubsectionValidator,
              v
            )
          )
          .flatMap<AdditionalSubsectionData>(listFromOption)
          .toArray()
          .map((section) => ({
            ...section,
            matchingComponents: initialComponentTeasersState(() =>
              getSearchResults('components', section.Query, 6, 0)
            ),
          })),
        status: 200,
      }
    else
      return {
        kind: 'failed',
        status: 404,
      }
  })
)

export async function getComponentOfTheDay(): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/components/day?language=${i18next.language}`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) {
    if (res.status == 404) return null
    throw Error(res.statusText)
  }
  return await res.json()
}

export const loadComponentOfTheDay = loadingAsyncState(() =>
  getComponentOfTheDay().then((raw) => {
    if (raw == null) return { kind: 'result', value: undefined, status: 200 }
    const maybeComponent = canSafelyCast<ComponentTeaserData>(
      componentTeaserValidator,
      {
        ...raw,
        ImageURL: raw.ImageURL || { Url: '', Title: '' },
      }
    )
    return maybeComponent.kind == 'r'
      ? { kind: 'result', value: maybeComponent.v, status: 200 }
      : { kind: 'failed', status: 404 }
  })
)
